/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_distortion': {
    width: 32,
    height: 21,
    viewBox: '0 0 32 21',
    data: '<path pid="0" d="M16 20.5c-4.838 0-8.873-3.436-9.8-8l-3.7-2h9l-5.042-3C7.732 3.443 11.522.5 16 .5c4.838 0 8.873 3.436 9.8 8l3.7 2h-10l6.042 3c-1.274 4.057-5.064 7-9.542 7z" stroke-miterlimit="16"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_distortion.js